import Axios from "axios";
import store2 from "store2";

let isRedirecting = false;

export const setupAxiosInterceptors = () => {
    Axios.interceptors.response.use(
        (response) => {
            if (response.data && response.data.Redirect && !isRedirecting) {
                isRedirecting = true;
                handleSessionExpired();
                return Promise.reject({ 
                    message: "Session expired - redirecting to login",
                    isSessionExpired: true 
                });
            }
            return response;
        },
        (error) => {
            if (error.response) {
                const status = error.response.status;
                
                if ((status === 401 || status === 403) && !isRedirecting) {
                    isRedirecting = true;
                    handleSessionExpired();
                    return Promise.reject({ 
                        message: "Unauthorized - session expired",
                        isSessionExpired: true,
                        originalError: error 
                    });
                }
            }
            
            return Promise.reject(error);
        }
    );
};

const handleSessionExpired = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("loginData");
    store2.remove("token");
    
    setTimeout(() => {
        window.location.href = "/user/login";
    }, 100);
};

